window.offersLoadMore = function offersLoadMore() {
    var size_li = $(".fullOfferList.featuredItemsRedesign ul li").length,
    x=3;

    console.log(size_li);

    $('.fullOfferList.featuredItemsRedesign ul li:lt('+x+')').show();

    $('.loadMore .button').click(function (e) {
        e.preventDefault();
        x= (x+5 <= size_li) ? x+5 : size_li;
        $('.fullOfferList.featuredItemsRedesign ul li:lt('+x+')').show();
    });
}

window.showDetails = function showDetails() {
    'use strict';

    $('#offerStockWrapper').hide();
    $('.offerStockLink').show();
    $('#offerDetailsWrapper').show();
}

window.showStock = function showStock() {
    'use strict';

    $('html, body').animate({scrollTop: 0}, 'slow');

    $('#offerDetailsWrapper').hide();
    $('.stickyHeader').hide();
    $('.offerStockLink').hide();
    $('#offerStockWrapper').show();
}

window.reloadFilter = function reloadFilter(trig, custom_value) {
    'use strict';

    $('#loadingOverlay').fadeIn();

    var filter = $('#offerFilter');

    var page_id = 0;
    if ($('#offer_page_id').length) {
        page_id = $('#offer_page_id').val();
    }

    var state = filter.attr('data-state');
    state = JSON.parse(state);
    state['current_url'] = filter.attr('data-url');
    state = JSON.stringify(state);

    var data = {
            state : state,
            action : (custom_value) ? trig.data('action') : trig.attr('data-action'),
            value : (custom_value) ? trig.data('value') : trig.val(),
            page_id : page_id,
            current_url : filter.attr('data-url'),
            franchise: filter.attr('data-franchise'),
            offer_type: filter.attr('data-type')
        };

    if (data.value == 0 && data.action.indexOf('set') === 0) {
        data.action = 're' + data.action + 's';
    }

    $.post('/modules/Offers/ajax/list.php', data, function(result) {

        var type, make, model, immediate_delivery,
            offer_url = '',
            data_state = JSON.parse(data.state);

        if (data.franchise) {
            make = data.franchise;
        } else if (data.action == 'resetMakes') {
            make = '';
        } else if (data.action == 'setMake') {
            make = data.value;
        } else {
            make = Object.keys(data_state.makes)[0];
        }

        if (data.action == 'resetTypes') {
            type = '';
        } else if (data.action == 'setType') {
            type = data.value;
        } else {
            type = Object.keys(data_state.types)[0];
        }

        if (data.action == 'resetModels' || data.action == 'resetMakes') {
            model = '';
        } else if (data.action == 'setModel') {
            model = data.value;
        } else {
            model = Object.keys(data_state.models)[0];
        }

        if (data.action == 'setImmediateDelivery') {
            immediate_delivery = $(this).data('value');
        }

        if (make) {
            make = make.toLowerCase();
            offer_url += '/' + make;
        }

        if (data.offer_type) {
            offer_url += '/' + data.offer_type;
        } else {
            offer_url += '/offers';
        }

        if (type) {
            type = type.replace(/\s/g, "-");
            offer_url += '/' + type;
        }

        if (model) {

            model = model.toLowerCase().capitalize().replace(/\s/g, "-");

            offer_url += '/' + model;
        }

        if (data.action == 'setImmediateDelivery') {
            offer_url += '#immediate-delivery';
        }

        // T111268
        offer_url = offer_url.toLowerCase();

        // t131694: current live offer pages for BMW have url /bmw/finance-and-offers
        if (data.offer_type == 'offers' || data.offer_type == 'finance-and-offers') {
            window.history.pushState(null, '', offer_url);
        }

        filter.attr('data-state', JSON.stringify(result.state));
        $('#offerFilter').replaceWith(result.filter);
        $('#offerList').html(result.list);
        $('.financeContent').replaceWith(result.finance);

        if ($('.js_offerFilterLinks').length) {
            // remove active class from filter links as we've filtered
            $('.js_offerFilterLinks li').removeClass('active');
            // add active class to filter links on redesign
            $('.js_offerFilterLinks a[data-value="' + trig.val() + '"]').parent().addClass('active');
        }

        $('.js_aprPopupTrigger').mtcOverlay();

        lazyLoadedImages.update();

        $('#loadingOverlay').fadeOut();

        reviewsOverlaySmall();

        fullReviewsOverlay();

        // TODO refactor this function
        $('.enquireOverlay').mtcOverlay({
            buttonHtml: '<div class="altCloseButton overlayCloseButton enquireClose"><a href="#"><i class="fa fa-remove"></i> Close</a></div>',
            onOpen: function () {
                var windowHeight = $(window).height(),
                    overlayHeight = (windowHeight);

                if($(window).width() < window.breakpoints.mobile) {

                    $('.enquireOverlay.overlayForm').height(overlayHeight);
                    $('.overlayBox').css({'top': 0});

                    $('.enquireOverlay').scroll(function() {

                        var header_height = 50,
                            $element = $('.enquireClose'),
                            offset,
                            off_top;

                        offset = $('.enquireOverlay form').offset();

                        if (offset.top < header_height /*&& !is_touch_device()*/) {
                            // user scrolled passed header
                            $element.addClass('stickMe');
                        } else {
                            $element.removeClass('stickMe');
                        }

                    });
                }
            }
        });

    }, 'json');
}

$(document).ready(function() {
    'use strict';

    var filter_wrapper = $('#offerFilterWrapper'),
        popped = ('state' in window.history && window.history.state !== null);

    if (window.location.hash.includes("#immediate-delivery")) {
        setTimeout(function() {
            $(".js_offersImmediateDelivery").click();
        }, 0);
    }

    if (filter_wrapper.length > 0) {
        filter_wrapper.on('change', 'select', function() {
            reloadFilter($(this));

            if ($('.js_offersImmediateDelivery').length) {
                $('.js_offersImmediateDelivery').removeClass('active');

                if ($(this).is('#offerFilter-type') && $('.js_setNewCarsFilter').hasClass('active')) {
                    $('.js_setNewCarsFilter').removeClass('active');
                }

                if ($(this).is('#offerFilter-type') && !$('.js_setNewCarsFilter').hasClass('active')) {
                    if ($(this).val() === 'New Cars') {
                        $('.js_setNewCarsFilter').addClass('active');
                    }
                }
            }
        });

        filter_wrapper.on('click submit', '#offerFilter-resetAll', function(e) {
            e.preventDefault();
            reloadFilter($(this));

            if ($('.js_offersImmediateDelivery').length) {
                $('.js_offersImmediateDelivery').removeClass('active');
                $('.js_setNewCarsFilter').removeClass('active');
            }
        });

        $('.js_offerFilterTabs').on('click submit', '.js_offersImmediateDelivery', function(e) {
            e.preventDefault();
            $(this).addClass('active');
            $(this).siblings().removeClass('active');
            reloadFilter($(this), true);
        });

        $('.js_setNewCarsFilter').on('click', function (e) {
            e.preventDefault();
            var value = $(this).data('value');

            if (!$(this).hasClass('active')) {
                $('#offerFilter-type').val(value).trigger('change');
            }

            $(this).addClass('active');
            $(this).siblings().removeClass('active');
        });

        // trigger select fire based on link data value to update filter
        filter_wrapper.on('click', '.js_offerFilterLinks a', function (e) {
            e.preventDefault();
            var value = $(this).data('value');
            $(this).parent().addClass('active').siblings().removeClass('active');

            $('#offerFilter-model').val(value).trigger('change');
        });
    }

    $('.offerStockLink').click(function(e) {
        e.preventDefault();

        history.replaceState({what: 'details'}, document.title);
        history.pushState({}, document.title + ' - Stock', window.location.pathname.replace(/\/+$/,'') + '/stock');

        showStock();

    });

    $('.backToOffer').click(function(e) {
        e.preventDefault();

        history.replaceState({what: 'stock'}, document.title);
        history.pushState({}, document.title.replace('/ \- Stock$/', ''), window.location.pathname.replace(/\/stock$/, ''));

        showDetails();

    });

    if (popped && $('.offerStockLink').length) {
        window.onpopstate = function(event) {
            if (event.state.what === 'details') {
                showDetails();
            } else if (event.state.what === 'stock') {
                showStock();
            }
        };
    }

    // console.log(window.onpopstate);

    /* Currently not needed
     $('#offerList').on('click', '.showRepresentativeExample', function(e) {
     $.ajax({
     url: '/modules/Offers/ajax/representative_example.php',
     data: {vehicle_ids: JSON.parse($(this).attr('data-vehicleIds'))}
     }).done(function(result) {
     $('.financeContent').replaceWith(result);
     });
     });
     */
});

String.prototype.capitalize = function() {
    return this.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
};
